import { createWrapper } from '@segment/analytics-consent-tools';
import { getCkyConsentCategories } from '@/util/cookie_consent_client';

/**
 * Maps CookieYes consent categories to Segment consent category names.
 * The names here must match the categories configured in the Segment UI
 * under Privacy → Consent Management.
 */
function getSegmentCategories() {
  const { analytics, functional, advertisement } = getCkyConsentCategories();
  return {
    Analytics: analytics,
    Functional: functional,
    Advertising: advertisement
  };
}

/**
 * Wraps the Segment AnalyticsBrowser instance with CookieYes consent awareness.
 *
 * Each destination is only initialised once its mapped consent category is
 * granted. When the user updates consent, CookieYes fires a
 * `cookieyes-consent-update` event and Segment re-evaluates which destinations
 * should now load.
 *
 * Usage:
 *   const analytics = withCookieYesConsent(AnalyticsBrowser.load({ writeKey }));
 */
export const withCookieYesConsent = createWrapper({
  getCategories: getSegmentCategories,

  registerOnConsentChanged: (fn) => {
    if (typeof window === 'undefined') return;
    window.addEventListener('cookieyes-consent-update', () => {
      fn(getSegmentCategories());
    });
  }
});
